import { Injectable } from '@angular/core';
import bridge from '@vkontakte/vk-bridge';
import { environment } from '../../environments/environment';

export type VkInstallState = 'idle' | 'installing' | 'binding' | 'error';

@Injectable({ providedIn: 'root' })
export class VkCommunityInstallService {
  async install(widgetId: string, appId?: string): Promise<VkInstallState> {
    try {
      const init = await bridge.send('VKWebAppInit');
      if (init?.result !== true) {
        return 'error';
      }

      let resolvedAppId = appId;
      if (!resolvedAppId) {
        const launchParams = await bridge.send('VKWebAppGetLaunchParams');
        if (launchParams?.vk_app_id) {
          resolvedAppId = String(launchParams.vk_app_id);
        }
      }

      if (!resolvedAppId) {
        return 'error';
      }

      const data = await bridge.send('VKWebAppAddToCommunity');
      if (!data?.group_id) {
        return 'error';
      }

      const bindUrl =
        `${environment.apiClear}v2/wg/vk-bind-group/${widgetId}` +
        `?aid=${encodeURIComponent(resolvedAppId)}` +
        `&gid=${encodeURIComponent(data.group_id)}`;

      window.location.href = bindUrl;
      return 'binding';
    } catch {
      return 'error';
    }
  }
}
